// Packages
import PropTypes from 'prop-types'

// Components
import TestSpecificationForm from 'modules/TestSpecifications/components/Form';

// Other
import useApi from 'hooks/useApi';

const TestSpecificationEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/testspecifications/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Test Specification updated!')) {

            onSubmit();
        }
    }

    return(
        <TestSpecificationForm 
            errors={errors} 
            testSpecification={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

TestSpecificationEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

TestSpecificationEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default TestSpecificationEditScreen;